import { lazy, Suspense } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { Loader } from '@/shared/ui/loader'

const BloodConsumptionsPage = lazy(
  () => import('@/pages/blood-consumption/ui/index'),
)

export const Route = createFileRoute(
  '/_protected/recipients/blood-consumption/',
)({
  component: () => (
    <Suspense fallback={<Loader />}>
      <BloodConsumptionsPage />
    </Suspense>
  ),
})
